import { routeToPageIdMapping } from 'src/app/routes/routeToPageIdMapping';

/**
 * Function to return the correct path after a look up in 'routeToPageIdMapping'
 *
 * For unlocalised path, it will return the path from argument.
 *
 * For localised path, it will strip out the language at the start of url
 * @param path localised/unlocalised path
 *
 * (ie. /id/job/managejob/express/create/select-ad-type)
 * @returns universal path
 *
 * (ie. /job/managejob/express/create/select-ad-type)
 */
export const getPathWithoutLocalisation = (path: string) => {
  const pageId = routeToPageIdMapping[path];
  if (pageId) return path;

  const unlocalisedRoute = `/${path.split('/').slice(2).join('/')}`;
  return unlocalisedRoute;
};
